import modal from './modal';

const messages = {
  ['Não encontrado']: () => `
    <p>Usuário não encontrado.</p>
    <p>
      Sua credencial de assessor não foi encontrada na nossa base de dados.<br >
      Favor entrar em contato com nossa central de atendimento para mais informações.
    </p>
    <p>
      Agente Autônomo de investimentos <br >
      Telefone: (11) 4935-2777 ou VOIP 1777. <br >
      Funcionamento: Dias úteis das 9:00h às 18:00h no horário de Brasília.
    </p>
  `,
  ['Sem permissão']: () => `
    <p>Usuário sem permissão.</p>
    <p>
      Você não possui permissão a esse sistema.<br >
      Favor entrar em contato para solicitar a permissão:
    </p>
    <p>
      Agente Autônomo de investimentos<br >
      Telefone: (11) 4935-2777 ou VOIP 1777.<br >
      Funcionamento: Dias úteis das 9:00h às 18:00h no horário de Brasília.
    </p>
  `,
  ['Pre assessor']: ({ name, url, emailStandardization }) => `
    <p>
      ${name != null ? `Olá, <strong>${name}</strong>` : 'Olá'}
      <br />
      Tudo bem?
    </p>
    <p>
      Se você for um novo assessor: <strong>Seja bem-vindo à XP Investimentos!</strong><br />
      Agora que você já tem o seu código de assessor em mãos, você deve realizar três processos para a liberação do seu acesso operacional:    
    </p>
    <ul style="list-style: decimal;">
      <li>
        <strong>Padronização do e-mail</strong>
        <p>
          Para você realizar a padronização solicite ao gestor do escritório que adicione seu e-mail no link <a href="https://portal.bhs.com.br/">https://portal.bhs.com.br/</a> e vincule o seu código de assessor “A12345” ao e-mail para que a padronização seja efetuada com sucesso.
          Quando a solicitação for finalizada você irá receber um e-mail de <a href="mailto:no-reply@bhs.com.br ">no-reply@bhs.com.br</a> com a confirmação.        
        </p>
      </li>
      <li>
        <strong>Conclusão da Trilha Obrigatória na UXP</strong>
        <p> 
          Para você finalizar a Trilha Obrigatória na UXP, basta acessar o link a seguir e consumir os conteúdos do curso. <br />
          ${url != null ? `<a href="${url}">Universidade XP</a>` : ''}
        </p>
      </li>
      <li>
        <strong>Padronização da Telefonia</strong>
        <p>
          Para você realizar a padronização da telefonia, envie um e-mail para <a href="mailto:op-ti-aai@xpi.com.br">op-ti-aai@xpi.com.br</a> mencionando: <br />
          Nome Completo; <br />
          Código do assessor; <br />
          Nome do escritório; <br />
        </p>
      </li>
    </ul>
    <p>
      Se tiver qualquer dúvida, dentro da UXP, você encontra os roteiros para realizar a Padronização de E-mail e Telefone.
      Acesse agora: <a href="${emailStandardization}">${emailStandardization}</a>    
    </p>
    <p>
      Se você já concluiu esses três passos, parabéns! A liberação do seu acesso foi solicitada, agora você deve aguardar até 3 dias úteis para a liberação completa do seu acesso operacional.
    </p>
    <p>
      Fique atento ao seu e-mail. O status de cada um dos passos para concluir seu acesso operacional será informado por lá.
    </p>
    <div class="redirect" style="display: none; opacity: 0;">
      Você está sendo redirecionado para a <strong>Universidade XP</strong> em <div class="_count"><span class="animate-countdown"><span>10...</span><span>9...</span><span>8...</span><span>7...</span><span>6...</span><span>5...</span><span>4...</span><span>3...</span><span>2...</span><span>1...</span><span>0...</span></span></div>
    </div>
  `,
  ['Usuário indisponível']: () => `
    <p>Usuário indisponível.</p>
    <p>
      Por favor acesse o Portal do Assessor no Taylor <a style="color: inherit;" target="_blank" href="https://xpinvestimentos.service-now.com/sp_assessor">https://xpinvestimentos.service-now.com/sp_assessor</a>
    </p>
    <p>
      Agente Autônomo de investimentos<br >
      Telefone: (11) 4935-2777 ou VOIP 1777.<br >
      Funcionamento: Dias úteis das 9:00h às 18:00h no horário de Brasília.
    </p>
  `,
  ['Sessao expirada']: () => `
    <p>Sua sessão foi finalizada.</p>
    <p>
      Identificamos um novo login em outro dispositivo. Certifique-se de que ninguém mais tem acesso a sua senha e token.
    </p>
    <p><span onclick="window.xpSession.logout" style="text-decoration: underline; cursor: pointer;">Clique aqui</span> para ir para o login</p>
  `,
  ['Bloqueio treinamento']: ({ url }) => `
    <p>Seu acesso foi bloqueado devido à não conclusão do “Treinamento Obrigatório Anual”. 
    Para restaurar seus acessos em até 24 horas solicitamos que ${url != null ? `<a href="${url}"> acesse a UXP </a>` : ''} e conclua o referido treinamento. 
    Após a conclusão, um fluxo automático é iniciado com o Time de Controle de Acessos para desbloqueio da sua conta neste período informado.</p>
    <p>
      <b>Não efetue a abertura de um chamado até que este período de 24 horas seja concluído.</b>
    </p>
    <p>
    Seu tempo de 24 horas já expirou e ainda não foi desbloqueado?
    </p>
    <p>
    Utilize a oferta do Taylor selecionando “Ajuste em acesso ou Perfil” e, em seguida, “Hub Web” 
    informe seu problema anexando seu certificado de conclusão do curso e aguarde um retorno via Taylor.
    </p>
  `,
};

export default {
  render: (msg = null, name = null, url = null, emailStandardization = null) => modal.render(messages[msg]({ name, url, emailStandardization }))
}